import datePicker from 'vue-bootstrap-datetimepicker';
import moment from 'moment';

Vue.component('edit-campaign', {
	template: `
        <tbody>
            <tr v-if="createForm.alert !== null">
                <td colspan="5">
                    <alert :type="createForm.alert.type" :message="createForm.alert.message" :errors="createForm.alert.errors"></alert>
                </td>
            </tr>

            <tr :class="{'bg-warning': status == 'in-progress', 'bg-success': status == 'complete'}">
                <td>
                    <select class="form-control" v-model="createForm.data.type" required="" :disabled="status != 'pending'">
                        <option></option>
                        <option value="email">Email</option>
                        <option value="sms">SMS</option>
                    </select>
                </td>

                <td>
                    <select class="form-control" v-model="createForm.data.template" required="" :disabled="status != 'pending'">
                        <option></option>
                        <option v-for="template in filteredTemplates" :value="template.id">
                            {{template.title}}
                        </option>
                    </select>
                </td>

                <td>
                    <select class="form-control" v-model="createForm.data.from" required="" :disabled="status != 'pending'">
                        <option></option>
                        <option v-for="email in config.emails" :value="email.id">
                            {{email.first_name}} {{email.last_name}} - {{email.email}}
                        </option>
                    </select>
                </td>

                <td>
                    <date-picker 
                        v-model="createForm.data.scheduled_at"
                        :disabled="status != 'pending'"
                        :config="tpOptions"
                        required=""
                    ></date-picker>
                </td>

                <td>
                    <div class="btn-group">
                        <button 
                            @click="createCampaign"
                            class="btn btn-primary"
                            :disabled="createForm.data.working || status != 'pending'"
                        >
                            <i class="fa fa-spin fa-spinner" v-if="createForm.data.working"></i>
                            <i class="fa fa-save"></i>
                        </button>

                        <button 
                            @click="deleteCampaign"
                            class="btn btn-danger"
                            :disabled="createForm.data.working || status != 'pending'"
                        >
                            <i class="fa fa-spin fa-spinner" v-if="createForm.data.working"></i>
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
	`,

	props: [
		'config', 'campaign'
	],

	components: {
        datePicker
    },

	data () {
		return {
            tpOptions: {
                format: 'DD/MM/YYYY HH:mm',
            },

			createForm: $.extend(true, new Form({
                data: {
                    type: '',
                    template: '',
                    from: '',
                    scheduled_at: null,
                },

                working: false,
            }), {}),

            filtered_templates: [],

            status: ''
		}
	},

    mounted () {
        if (this.campaign) {
            this.createForm.data.type = this.campaign.communication_type;
            this.createForm.data.template = this.campaign.template_id;
            this.createForm.data.from = this.campaign.from_id;
            this.createForm.data.scheduled_at = moment(this.campaign.scheduled_at).format('DD/MM/YYYY HH:mm');
            this.status = this.campaign.status;
        }
    },

	methods: {
		createCampaign () {
			this.createForm.working = true;

			this.createForm.data.client = this.config.id;

            Http.post(`/api/campaign/update/${this.campaign.id}`, this.createForm, {}).then((response) => {
                this.$emit('on-fetch-campaigns');

                this.createForm.working = false;

                this.createForm.resetForm();
            });
		},

        deleteCampaign () {
            var c = confirm("Are you sure you want to delete this camapign?");

            if (c) {
                Http.post(`/api/campaign/delete/${this.campaign.id}`, this.createForm, {}).then((response) => {
                    this.$emit('on-fetch-campaigns');

                    this.createForm.working = false;
                });
            }
        }
	},

    computed: {
        filteredTemplates () {
            if (!this.createForm.data.type) {
                return [];
            }

            return this.config.templates.filter(t => t.communication_type == this.createForm.data.type);
        }
    }
})